import { z } from "zod";

import { IAppDetailsSchema } from "../abstractions";

// This structure is a hack to get around the service requring us to pass the entire object back &
// forth while also acting on partial objects in rather unexpected ways like the omission of color/outline icons 
// deleting the icon from the service side.
export const IAppDetailsDtoSchema = IAppDetailsSchema.extend({
  colorIcon: z.string(),
  outlineIcon: z.string(),
  // For the time being if we encounter properties that need to be written back on every app update but are not
  // useful for the client we can add them here. 
});

export type IAppDetailsDto = z.infer<typeof IAppDetailsDtoSchema>;
